import { styled, Typography } from "@mui/material";
import { orange } from "@mui/material/colors";

export const Container = styled("ul")({
  paddingInlineStart: 0,
  margin: 0,
});

export const Step = styled("li")(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
  borderRadius: "0.2em",
  padding: `${theme.spacing(0.75)} ${theme.spacing(1)}`,
  position: "relative",
  color: theme.palette.biarri.secondary.darkGrey,
  backgroundColor: theme.palette.grey[200],
  fontSize: theme.typography.size.small,

  "& svg": {
    fontSize: 15,
  },

  "&.InProgress": {
    backgroundColor: orange[300],
  },
  "&.Idle": {
    backgroundColor: theme.palette.grey[200],
  },
  "&.Success": {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
  },
  "&.Error": {
    color: theme.palette.error.contrastText,
    backgroundColor: theme.palette.error.main,
  },
  "&.Cancelling": {
    backgroundColor: theme.palette.grey[400],
  },
}));

export const StepLabel = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.size.small,
  lineHeight: "12px",
}));
